import { lazy } from 'react';
import { ALL_ROUTES } from './navigation';

/**
 * Lazy page component for each navigation path. Kept separate from
 * navigation.js so the doc template can read the nav data without
 * (indirectly) importing every page — see the note in navigation.js.
 */
export const PAGES = {
  '/': lazy(() => import('../pages/Overview')),
  '/testallcomponents/home': lazy(() => import('../pages/TestAllComponents/TestAllComponents')),
  '/collector/ftp-server': lazy(() => import('../pages/CollectorServices/FTPServer')),
  '/collector/ftp-collector': lazy(() => import('../pages/CollectorServices/FTPCollector')),
  '/collector/email-collector': lazy(() => import('../pages/CollectorServices/EmailCollector')),
  '/collector/api-scanner': lazy(() => import('../pages/CollectorServices/ApiScanner')),
  '/collector/scraper-service': lazy(() => import('../pages/CollectorServices/ScraperService')),
  '/supplier/supplier-dashboard': lazy(() => import('../pages/SupplierServices/SupplierDashboard')),
  '/supplier/union-dashboard': lazy(() => import('../pages/SupplierServices/UnionDashboard')),
  '/supplier/config-options-designer': lazy(() => import('../pages/SupplierServices/ConfigOptionsDesigner')),
  '/supplier/product-configurations': lazy(() => import('../pages/SupplierServices/ProductConfigurations')),
  '/supplier/audit-files': lazy(() => import('../pages/SupplierServices/AuditFiles')),
  '/document-builder/pdf-generator': lazy(() => import('../pages/DocumentBuilder/PDFGenerator')),
  '/document-builder/pdf-storage': lazy(() => import('../pages/DocumentBuilder/PDFStorage')),
  '/document-builder/template-builder': lazy(() => import('../pages/DocumentBuilder/TemplateBuilder')),
  '/document-builder/document-parser': lazy(() => import('../pages/DocumentBuilder/DocumentParser')),
  '/flow/flow-dashboard': lazy(() => import('../pages/FlowServices/FlowDashboard')),
  '/document-format-converter/document-format-converter-dashboard': lazy(() => import('../pages/DocumentFormatConverter/DocumentFormatConverterDashboard')),
  '/testonecorecomponents/home': lazy(() => import('../pages/TestOneCoreComponents/TestOneCoreComponents')),
  '/onecore/communication-component': lazy(() => import('../pages/OneCore/CommunicationComponent')),
  '/onecore/booking-component': lazy(() => import('../pages/OneCore/BookingComponent')),
  '/onecore/crm-component': lazy(() => import('../pages/OneCore/CRMComponent')),
  '/onecore/nps-component': lazy(() => import('../pages/OneCore/NPSComponent')),
  '/testfinancialcomponents/home': lazy(() => import('../pages/TestFinancialComponents/TestFinancialComponents')),
  '/financial/payment-widget': lazy(() => import('../pages/FinancialServices/PaymentWidget')),
  '/financial/payments-dashboard': lazy(() => import('../pages/FinancialServices/PaymentsDashboard')),
  '/financial/usage-dashboard': lazy(() => import('../pages/FinancialServices/UsageDashboard')),
  '/financial/aceve-pay-settings': lazy(() => import('../pages/FinancialServices/AcevePaySettings')),
  '/financial/onboarding-dashboard': lazy(() => import('../pages/FinancialServices/OnboardingDashboard')),
  '/financial/payment-landing': lazy(() => import('../pages/FinancialServices/PaymentLanding')),
  '/financial/payment-install-modal': lazy(() => import('../pages/FinancialServices/PaymentInstallModal')),
  '/financial/bank-connect': lazy(() => import('../pages/FinancialServices/BankConnect')),
  '/financial/bank-id-flow': lazy(() => import('../pages/FinancialServices/BankIdFlow')),
};

/** ALL_ROUTES with the page component attached, ready for <Route>s in App.js. */
export const APP_ROUTES = ALL_ROUTES.map((route) => ({ ...route, component: PAGES[route.pageKey] }));
